import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const chillHoursBelow45F: typeof valueTypeRenderers.chillHoursBelow45F = {
  label: () => unitConverter.chillHoursBelow45F().title(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.chillHoursBelow45F().title(),
      render: (n) => unitConverter.chillHoursBelow45F(n).valueAsString(),
    }),
}
